import { Component, OnInit } from '@angular/core';
import { WalletService } from 'src/app/services/api/wallet.service';
import { WinService } from 'src/app/services/win.service';


@Component({
	selector: 'app-wallet',
	templateUrl: './wallet.component.html',
	styleUrls: ['./wallet.component.scss']
})
export class WalletComponent implements OnInit {

	wallet_history:any = [];

	constructor(
		public winService: WinService,
		public walletService: WalletService
	) { }

	ngOnInit(): void {
		

		let url = this.walletService.getStoreUrl('/V1/hnd-wallet/mine/history?page=1&limit=10');
		this.walletService.doRequest(url, null, 'GET').then((data:any) => {
			if(!data.error && data.result){
				this.wallet_history = data.result;
			}
		});
	}

}
